import { add, format, parseISO } from "date-fns";
import { TIME_FORMAT } from "./TimeZoneSelector.constants";

/**
 * Formats the time and timezone string based on the given parameters
 * @param tz - Timezone offset in hours
 * @param serverTime - Server time string
 * @param fetchedTime - Timestamp when the server time was fetched
 * @returns Tuple of [formatted time string, timezone string]
 */
export const getFieldTextValues = (
  tz: number,
  serverTime: string | undefined,
  fetchedTime: number
): [string, string] => {
  if (!serverTime) {
    return ["UTC", ""];
  }

  let tzStr = "";
  if (tz > 0) tzStr = "+" + tz;
  else if (tz < 0) tzStr = "" + tz;

  const secondsDiff = (Date.now() - fetchedTime) / 1000;
  let date = parseISO(serverTime);
  date = add(date, { hours: tz, seconds: secondsDiff });
  const formattedTime = format(date, TIME_FORMAT);

  return [formattedTime, tzStr];
};
